module.exports = __webpack_public_path__ + "img/深圳职业.f7e39c57.png";